import { render, staticRenderFns } from "./PurchaseInvoicesListFilters.vue?vue&type=template&id=37d04b18&scoped=true&"
import script from "./PurchaseInvoicesListFilters.vue?vue&type=script&lang=js&"
export * from "./PurchaseInvoicesListFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d04b18",
  null
  
)

export default component.exports